import { Link } from "react-router-dom";

export default function Error400() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-6 text-center" dir="rtl">
      
      {/* Logo */}
      <img
        src="https://media.base44.com/images/public/user_69729b1c2410c5c031f1d29a/291b90bb1_.png"
        alt="مغاسل القمر الأبيض"
        className="w-24 h-24 object-contain mb-6"
      />

      {/* Error Code */}
      <div className="text-8xl font-black text-primary mb-2 leading-none">400</div>

      {/* Title */}
      <h1 className="text-2xl font-black text-foreground mb-3">
        طلب غير صالح
      </h1>

      {/* Description */}
      <p className="text-muted-foreground text-base max-w-sm mb-8 leading-relaxed">
        عذراً، تعذّر معالجة طلبك بسبب بيانات غير صحيحة. يرجى المحاولة مرة أخرى أو العودة للصفحة الرئيسية.
      </p>

      {/* Actions */}
      <div className="flex flex-col sm:flex-row gap-3 w-full max-w-xs">
        <Link
          to="/"
          className="flex-1 py-3 bg-primary text-primary-foreground font-bold rounded-xl text-center hover:bg-primary/90 transition-colors"
        >
          🏠 الصفحة الرئيسية
        </Link>
        <button
          onClick={() => window.history.back()}
          className="flex-1 py-3 border-2 border-border text-foreground font-bold rounded-xl hover:bg-secondary transition-colors"
        >
          ← رجوع
        </button>
      </div>

      {/* Footer Brand */}
      <div className="mt-12 text-sm text-muted-foreground">
        <p className="font-semibold text-foreground">مغاسل القمر الأبيض</p>
        <a
          href="https://wa.me/966500000000"
          target="_blank"
          rel="noreferrer"
          className="text-green-600 hover:underline mt-1 block"
        >
          📞 تواصل معنا عبر واتساب
        </a>
      </div>
    </div>
  );
}